import { useContext } from 'react'

import { useSession } from '@marketplace-web/shared/session-data'
import { useCountdown } from '@marketplace-web/shared/ui-helpers'
import { ShippingDetailsContext } from '@marketplace-web/item-page/item-page-data'

export const useCanTransact = ({
  canBuy,
  canInstantBuy,
  isReserved,
  isHidden,
  reservedForUserId,
  closetCountdownEndDate,
}) => {
  const { shippingDetails } = useContext(ShippingDetailsContext)
  const { isCountdownActive } = useCountdown(closetCountdownEndDate)
  const currentUserId = useSession().user?.id

  const isItemReservedForBuyer = reservedForUserId === currentUserId
  const canTransact =
    canBuy &&
    canInstantBuy &&
    (!isReserved || isItemReservedForBuyer) &&
    !isHidden &&
    !!shippingDetails &&
    !isCountdownActive

  return canTransact
}
